<template>
  <div>
    <v-container fluid>
      <v-skeleton-loader
        :loading="!flagNav"
        transition="scale-transition"
        max-height="64"
        type="table-heading">
        <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">
            {{ $t("ReportQuestion") }}
          </v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader>
      <v-card class="reportdata-card-main" style="margin-top: 1rem">
        <v-card-title class="d-flex align-center justify-space-between mb-4">
          <div class="d-flex align-center">
            <v-icon color="primary" class="mr-3" size="28">
              mdi-chart-bar
            </v-icon>
            <h3 class="text-h5 font-weight-bold text-primary">
              Question Report Management
            </h3>
          </div>
        </v-card-title>

        <v-card-text style="padding: 0">
          <!-- Main Filter Row -->
          <v-row class="mb-4">
            <!-- Date Range Section -->
            <v-col cols="12" md="8">
              <div class="reportdata-filter-section">
                <h4 class="reportdata-section-title mb-3">
                  <v-icon class="mr-2 ml-2" color="primary" size="20">
                    mdi-calendar-range
                  </v-icon>
                  Date Range
                </h4>
                <v-row class="px-4">
                  <v-col cols="5">
                    <v-card variant="outlined" class="reportdata-card-outlined">
                      <v-card-text class="pa-3">
                        <v-menu
                          v-model="startDateFlag"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          location="bottom"
                          min-width="auto">
                          <template #activator="{ props }">
                            <v-text-field
                              id="startdate-field-reportquestiontop10"
                              v-model="startDate"
                              label="Start Date"
                              prepend-inner-icon="mdi-calendar"
                              readonly
                              variant="outlined"
                              v-bind="props"
                              density="compact"
                              color="primary"
                              class="reportdata-field-date"
                              clearable>
                              <template #append-inner>
                                <v-tooltip location="top" max-width="200">
                                  <template #activator="{ props }">
                                    <v-icon
                                      size="small"
                                      color="grey-darken-1"
                                      v-bind="props">
                                      mdi-information-outline
                                    </v-icon>
                                  </template>
                                  <span>Select start date for report</span>
                                </v-tooltip>
                              </template>
                            </v-text-field>
                          </template>
                          <v-date-picker
                            id="startdate-datapicker-reportquestiontop10"
                            v-model="startDate"
                            :max="endDate != null ? endDate : null"
                            @update:model-value="
                              (val) => {
                                startDate = formatDate(val);
                                startDateFlag = false;
                              }
                            "
                            color="primary"></v-date-picker>
                        </v-menu>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="2" class="d-flex align-center justify-center">
                    <v-icon color="grey-darken-2" size="24">
                      mdi-arrow-right
                    </v-icon>
                  </v-col>

                  <v-col cols="5">
                    <v-card variant="outlined" class="reportdata-card-outlined">
                      <v-card-text class="pa-3">
                        <v-menu
                          v-model="endDateFlag"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          location="bottom"
                          min-width="auto">
                          <template #activator="{ props }">
                            <v-text-field
                              id="enddate-field-reportquestiontop10"
                              v-model="endDate"
                              label="End Date"
                              prepend-inner-icon="mdi-calendar"
                              readonly
                              variant="outlined"
                              v-bind="props"
                              density="compact"
                              color="primary"
                              class="reportdata-field-date"
                              clearable>
                              <template #append-inner>
                                <v-tooltip location="top" max-width="200">
                                  <template #activator="{ props }">
                                    <v-icon
                                      size="small"
                                      color="grey-darken-1"
                                      v-bind="props">
                                      mdi-information-outline
                                    </v-icon>
                                  </template>
                                  <span>Select end date for report</span>
                                </v-tooltip>
                              </template>
                            </v-text-field>
                          </template>
                          <v-date-picker
                            id="enddate-datapicker-reportquestiontop10"
                            v-model="endDate"
                            :min="startDate != null ? startDate : null"
                            @update:model-value="
                              (val) => {
                                endDate = formatDate(val);
                                endDateFlag = false;
                              }
                            "
                            color="primary"></v-date-picker>
                        </v-menu>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
            </v-col>

            <!-- Status Section -->
            <v-col cols="12" md="4">
              <div class="reportdata-filter-section">
                <h4 class="reportdata-section-title mb-3">
                  <v-icon class="mr-2" color="primary" size="20">
                    mdi-progress-check
                  </v-icon>
                  Processing Status
                </h4>
                <v-card
                  variant="outlined"
                  class="reportdata-card-outlined reportdata-card-stats mr-4">
                  <v-card-text class="pa-3">
                    <div class="d-flex align-center justify-center">
                      <v-chip
                        size="large"
                        :color="
                          dataUpdate === dataAll && dataAll > 0
                            ? 'success'
                            : 'primary'
                        "
                        variant="outlined"
                        class="px-4">
                        <v-icon class="mr-2">
                          {{
                            dataUpdate === dataAll && dataAll > 0
                              ? "mdi-check-circle"
                              : "mdi-clock-outline"
                          }}
                        </v-icon>
                        {{ dataUpdate }} / {{ dataAll }}
                      </v-chip>
                    </div>
                  </v-card-text>
                </v-card>
              </div>
            </v-col>
          </v-row>

          <!-- Prompt Template Section -->
          <v-row class="mb-4">
            <v-col cols="12">
              <div class="reportdata-filter-section">
                <h4 class="reportdata-section-title mb-3">
                  <v-icon class="mr-2 ml-2" color="primary" size="20">
                    mdi-text-box-outline
                  </v-icon>
                  Prompt Template
                </h4>
                <v-card
                  variant="outlined"
                  class="reportdata-card-outlined reportdata-question-prompt-card mx-4">
                  <v-card-text class="pa-4">
                    <v-textarea
                      id="prompttemplate-textarea-reportquestiontop10"
                      label="Prompt Template"
                      variant="outlined"
                      counter
                      auto-grow
                      rows="5"
                      v-model="promptTemplate"
                      :maxlength="maxLengthChar"
                      :rules="[validatePrompt(promptTemplate)]"
                      required
                      color="primary"
                      prepend-inner-icon="mdi-code-tags"
                      clearable>
                      <template #append-inner>
                        <v-tooltip location="top" max-width="300">
                          <template #activator="{ props }">
                            <v-icon
                              size="small"
                              color="grey-darken-1"
                              v-bind="props">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>
                            Enter your prompt template for question generation
                          </span>
                        </v-tooltip>
                      </template>
                    </v-textarea>
                  </v-card-text>
                </v-card>
              </div>
            </v-col>
          </v-row>

          <!-- Action Buttons Row -->
          <v-row class="mb-4">
            <v-col cols="12">
              <v-card variant="outlined" class="reportdata-card-action">
                <v-card-text class="pa-4">
                  <div
                    class="d-flex justify-space-between align-center flex-wrap ga-3 reportdata-flex-responsive">
                    <!-- Left Side - Process Button -->
                    <div v-show="!isViewOnly" class="reportdata-action-group">
                      <v-btn
                        id="button-process-reportquestiontop10"
                        color="secondary"
                        variant="elevated"
                        size="large"
                        @click="Search()"
                        class="reportdata-btn-process"
                        prepend-icon="mdi-cog">
                        PROCESS
                      </v-btn>
                    </div>

                    <!-- Right Side - Auto Refresh Button -->
                    <div class="reportdata-action-group ml-auto">
                      <v-btn
                        id="button-autorefresh-reportquestiontop10"
                        color="info"
                        variant="elevated"
                        size="large"
                        @click="AutoRefresh()"
                        class="reportdata-btn-refresh"
                        prepend-icon="mdi-refresh">
                        Refresh
                        <v-chip
                          size="small"
                          color="white"
                          variant="elevated"
                          class="ml-2">
                          {{ dataUpdate }} / {{ dataAll }}
                        </v-chip>
                      </v-btn>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <!-- Data Table with Modern Styling -->
          <v-card class="reportdata-card-table">
            <div class="reportdata-table-container">
              <v-data-table-server
                :items="dataTable"
                :headers="headers"
                hide-default-footer
                class="reportdata-table-modern"
                density="comfortable"
                hover>
                <template #top>
                  <v-toolbar flat color="grey-lighten-4" class="table-toolbar">
                    <v-toolbar-title class="text-h6 font-weight-medium">
                      <v-icon class="mr-2" color="primary">mdi-table</v-icon>
                      Question Report Data ({{ dataTable.length }} records)
                    </v-toolbar-title>
                  </v-toolbar>
                </template>

                <template #item="{ item }">
                  <tr class="reportdata-table-row">
                    <td class="text-center">
                      {{ item.no }}
                    </td>
                    <td>
                      <div class="reportdata-text-container">
                        <span
                          v-for="(subItem, index) in item.title"
                          :key="subItem"
                          class="reportdata-text-standard">
                          {{ subArray(subItem, index, item.title.length) }}
                        </span>
                      </div>
                    </td>
                    <td class="text-center">
                      {{ substringLong(item.count) }}
                    </td>
                  </tr>
                </template>
              </v-data-table-server>
            </div>
          </v-card>
        </v-card-text>
      </v-card>
    </v-container>
    <v-overlay :value="loading">
      <v-dialog v-model="loading" persistent width="300">
        <v-card color="#1976D2" dark>
          <v-card-text class="white--text">
            Loading Please Wait...
            <v-progress-linear
              indeterminate
              color="#FAA91B"
              class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay>
  </div>
</template>
<script>
import dateUtils from "../plugins/date-utils";
import moment from "moment";
import checkPermissionTwo from "@/api/function.js";
import LogTrace from "@/api/function.js";
export default {
  name: "ReportQuestion",
  inject: ["flagNav","FontColorTitle","SubNavbarBackGround"],
  mixins: [checkPermissionTwo, LogTrace],
  data: () => ({
    today: null,
    loading: false,
    options: {},

    startDateFlag: false,
    endDateFlag: false,
    startDate: null,
    endDate: null,
    promptTemplate: "",
    maxLengthChar: 4000,
    dataUpdate: 0,
    dataAll: 0,

    dataTable: [],
  }),
  computed: {
    isViewOnly() {
      return this.$pagePermission && this.$pagePermission.isViewOnly('ReportQuestionTop10');
    },
    headers() {
      return [
        {
          title: this.$t("no"),
          align: "center",
          width: "100px",
          sortable: false,
        },
        {
          title: "Question Category",
          align: "left",
          sortable: false,
          width: "500px",
        },
        {
          title: "Total",
          align: "center",
          sortable: false,
          width: "100px",
        },
      ];
    },
  },
  watch: {
    // options: {
    //   handler() {
    //     this.GetReport();
    //   },
    //   deep: true,
    // },
  },
  methods: {
    formatDate(dateInput) {
      if (!dateInput) {
        return "";
      }
      if (
        typeof dateInput === "string" &&
        /^\d{4}-\d{2}-\d{2}$/.test(dateInput)
      ) {
        return dateInput;
      }

      const d = new Date(dateInput);
      if (isNaN(d.getTime())) {
        return dateInput.toString().substr(0, 10);
      }

      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const date = `${year}-${month}-${day}`;
      return date;
    },
    validatePrompt(inputValue) {
      if (!inputValue) {
        return true;
      }
      if (this.maxLengthChar == null) {
        return true;
      } else {
        return (
          inputValue.length <= this.maxLengthChar ||
          "กรุณากรอกข้อมูลตัวอักษรไม่เกิน " +
            this.convertNumberToStringFormat(this.maxLengthChar)
        );
      }
    },

    isTwoDecimalPlaces(number) {
      const regex = /^\d+(\.\d{1,2})?$/;
      return regex.test(number.toString());
    },

    convertNumberToStringFormat(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    Search() {
      let self = this;
      self.loading = true;
      self.QuestionGenerate();
    },

    QuestionGenerate() {
      let self = this;
      self.loading = true;

      if (
        self.startDate != null &&
        self.endDate != null &&
        self.promptTemplate != null &&
        self.promptTemplate != ""
      ) {
        let temp = {
          StartDate: self.startDate,
          EndDate: self.endDate,
          Prompt: self.promptTemplate,
        };

        self.$call.QuestionGenerate(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.dataUpdate = dataResponse.data.processingCompleted;
              self.dataAll = dataResponse.data.processAll;
              self.AutoRefresh();
            }
            self.loading = false;
          },
          (errorResource) => {
            self.loading = false;
            console.error(errorResource);
          }
        );
      } else {
        self.$swal.fire({
          icon: "warning",
          title: self.$t("warning"),
          text: "Please fill the required fields!!!",
          showConfirmButton: false,
          timer: 1800,
        });
        self.loading = false;
        return;
      }
    },

    async AutoRefresh() {
      let self = this;
      let death_waiting = true;
      do {
        self.GetReport();
        if (
          window.location.pathname != "/ReportQuestionTop10" ||
          self.dataUpdate == self.dataAll
        ) {
          death_waiting = false;
        }
        await new Promise((resolve) => setTimeout(resolve, 5000));
      } while (death_waiting);
    },

    GetReport() {
      let self = this;
      // self.loading = true;

      let temp = {};

      self.$call.GetReportQuestion(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            if (dataResponse.data.requestReport != null) {
              self.startDate =
                dataResponse.data.requestReport.startDate != null
                  ? dataResponse.data.requestReport.startDate.split("T")[0]
                  : self.startDate;
              self.endDate =
                dataResponse.data.requestReport.endDate != null
                  ? dataResponse.data.requestReport.endDate.split("T")[0]
                  : self.endDate;
              self.promptTemplate = dataResponse.data.requestReport.prompt;
            }
            self.dataUpdate = dataResponse.data.processingCompleted;
            self.dataAll = dataResponse.data.processAll;
            self.dataTable = dataResponse.data.listData ?? [];
          } else {
            self.dataTable = [];
          }
          // self.loading = false;
        },
        (errorResource) => {
          // self.loading = false;
          console.error(errorResource);
        }
      );
    },

    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },

    convertDateToString2(date, seperator = "-") {
      return dateUtils.getStringFromDatePickFormatDatePick2(
        moment(date).toDate(),
        seperator
      );
    },

    substringLong(value) {
      if (value == null) {
        return "-";
      }
      if (value.length > 81) {
        return value.substring(0, 80) + ".....";
      }
      return value;
    },

    subArray(value, index, sum) {
      if (index == sum - 1) {
        return value;
      } else {
        return value + ", ";
      }
    },
  },
  mounted() {
    let self = this;
    self.GetDate();
    var date = new Date();
    self.endDate = self.convertDateToString2(date);
    date.setDate(date.getDate() - 30);
    self.startDate = self.convertDateToString2(date);
    self.GetReport();
  },
};
</script>
<style scoped>
.reportdata-question-prompt-card {
  background: rgba(25, 118, 210, 0.02) !important;
}
</style>
